import { render, staticRenderFns } from "./ReadSuporte.vue?vue&type=template&id=3119ee61"
import script from "./ReadSuporte.vue?vue&type=script&lang=js"
export * from "./ReadSuporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports